import { InjectionToken } from '@angular/core';

export const DATE_PIPE_DEFAULT_TIMEZONE = new InjectionToken<string>('timeZone');
